module.exports = __webpack_public_path__ + "media/audio78.c3d2b82a.mp3";